import { createSlice } from "@reduxjs/toolkit"

const mediaManagerSlice = createSlice({
  name: 'mediaManager',
  initialState: {
    medias: null,
    errors: [],
    displayedContent: null
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateMedias: (state, action) => {
      state.medias = action.payload
    },
    updateDisplayedContent: (state, action) => {
      state.displayedContent = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { fullUpdate, updateMedias, updateErrors, updateDisplayedContent } = mediaManagerSlice.actions

export default mediaManagerSlice.reducer